import { Menu, MenuItem, MenuList } from "@chakra-ui/react";
import { BiEnvelope, BiPencil, BiTrashAlt } from "react-icons/bi";
import { membershipUtil } from ".";
import { ComponentRequireRole } from "../../../components/component-require-role";
import { PaddedIcon } from "../../../components/ui/button/Icon";
import Workspace from "../../../components/workspace";
import { roleMap } from "../../../config/roleMapping";

const Member = ({ member, formModal, smsModal, deleteMemberDialog, setSelected }) => {
   return (
      <Workspace.ItemWrapper
         onClick={() => {
            setSelected(member);
            formModal.onOpen();
         }}>
         <div className="flex items-center px-4 py-5 gap-x-4 md:gap-x-6">
            <input type="checkbox" onClick={(e) => e.stopPropagation()} />
            <div className="grid gap-x-3 grid-cols-12 w-full items-center">
               <div className="col-span-6 overflow-hidden overflow-ellipsis">
                  <p className="font-bold" title="Member name">{`${member.firstName} ${member.lastName}`}</p>
                  <small className="member-record__phone" title="Member phone">{`${member.phoneNo || ""}`}</small>
               </div>
               <p className="col-span-3">{member.membershipLevel}</p>
               <p className="col-span-1">{member.branchCode}</p>
               <Workspace.ItemActionsWrapper>
                  <PaddedIcon variant="primary" title={`Edit ${member.firstName} ${member.lastName} details`} aria-label="edit">
                     <BiPencil className="text-lg" />
                  </PaddedIcon>

                  <Menu>
                     <Workspace.ItemMenuButton />
                     <MenuList className="!py-4">
                        <ComponentRequireRole requiredRoles={[roleMap.pastoralCareDirectorate]}>
                           <>
                              {membershipUtil.memberHasPhoneNumber(member) ? (
                                 <MenuItem
                                    className="gap-2 !py-3"
                                    onClick={(e) => {
                                       setSelected(member);
                                       e.stopPropagation();
                                       smsModal.onOpen();
                                    }}>
                                    <BiEnvelope /> Send SMS
                                 </MenuItem>
                              ) : (
                                 <MenuItem className="gap-2 !py-3 !text-gray-400 cursor-default">
                                    <BiEnvelope /> Send SMS
                                 </MenuItem>
                              )}
                              <MenuItem
                                 className="flex gap-2 !py-3 !text-red-600"
                                 onClick={(e) => {
                                    setSelected(member);
                                    e.stopPropagation();
                                    deleteMemberDialog.onOpen();
                                 }}>
                                 <BiTrashAlt /> Delete
                              </MenuItem>
                           </>
                        </ComponentRequireRole>
                     </MenuList>
                  </Menu>
               </Workspace.ItemActionsWrapper>
            </div>
         </div>
      </Workspace.ItemWrapper>
   );
};

export default Member;
